export default "__VITE_ASSET__CDKT9flq__"